// toast-layout.service.ts
import { Injectable, Renderer2, RendererFactory2, Inject, NgZone, DOCUMENT } from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { ToolState } from '@igo2/integration';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastLayoutService {
  private renderer: Renderer2;

  constructor(
    private toastr: ToastrService,
    private toolState: ToolState,
    private ngZone: NgZone,
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  initializeToastLayout(): Observable<void> {
    const layoutReady$ = new Subject<void>();

    this.ngZone.runOutsideAngular(() => {
      const interval = setInterval(() => {
        const mapBrowser = this.document.querySelector('igo-map-browser');
        const sidenav = this.document.querySelector('mat-sidenav');

        if (mapBrowser && sidenav) {
          clearInterval(interval);

          const divToastContainer = this.renderer.createElement('div');
          this.renderer.setAttribute(divToastContainer, 'id', 'banner-toast-container');
          this.renderer.insertBefore(mapBrowser, divToastContainer, mapBrowser.firstChild);

          this.toastr.overlayContainer = {
            getContainerElement: () => divToastContainer
          } as any;

          //divToastContainer =  this.document.getElementById('banner-toast-container');
          // divToastContainer.addEventListener('click', (event) => {
          //   const target = event.target as HTMLElement;
          //   if (target?.classList.contains('open-comment-tool')) {
          //     event.preventDefault();
          //     event.stopPropagation();
          //     this.toolState.toolToActivateFromOptions({
          //       tool: 'sigt-inscrire-commentaire',
          //       options: null
          //     });
          //   }
          // });

          // ✅ Observe sidenav for open state
          const observer = new MutationObserver(() => {
            const isOpen = sidenav.getAttribute('aria-expanded') === 'true' ||
                          sidenav.classList.contains('mat-drawer-opened') ||
                          sidenav.classList.contains('mat-sidenav-opened');

            if (isOpen) {
              observer.disconnect(); // trigger juste la première fois que ça arrive
              this.ngZone.run(() => layoutReady$.next());
              layoutReady$.complete();
            }
          });

          observer.observe(sidenav, {
            attributes: true,
            attributeFilter: ['class', 'style', 'aria-expanded']
          });
        }
      }, 100);
    });

    return layoutReady$.asObservable();
  }
}
